{{item.translation_key||item.label| translation|translationFromString | transformText :item?.text_transform}}
<div *ngFor="let integration of integrations">
    <p-checkbox binary="true" [inputId]="integration.name" (onChange)="integrationsUpdated()" [(ngModel)]="integration.selected" [disabled]="checkDisable()">
    </p-checkbox>
    <label [for]="integration.name">{{integration.friendly_name || integration.name}}</label>

</div>
